/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { Type } from '@sinclair/typebox';

// TODO: Once merchant monitoring structure is stable, update this schema
var MerchantMonitoringPluginSchema = Type.Optional(Type.Object({
  data: Type.Optional(Type.Object({}, {
    additionalProperties: true
  }))
}));

export { MerchantMonitoringPluginSchema };
//# sourceMappingURL=merchant-monitoring-plugin-schema.js.map
